import apiRequest from "utils/apiRequestWithErrorCode";
import type { Domain } from "@dashboard-v3/api";

export async function getDomainsList() {
  return apiRequest<Domain[]>("GET", "/domains");
}
